import React, { useEffect } from 'react';
import { Box, colors } from '@mui/material';
import makeStyles from '@mui/styles/makeStyles';
import useProgressContext from 'src/hooks/useProgressContext';

const useStyles = makeStyles(() => ({
  box: {
    backgroundColor: colors.common.white,
    minHeight: '100%'
  }
}));

const LoadingScreen = () => {
  const classes = useStyles();
  const { setLoading } = useProgressContext();

  useEffect(() => {
    setLoading(true);

    return () => {
      setLoading(false);
    };
  }, []);

  return <Box className={classes.box} />;
};

export default LoadingScreen;
